export type ProductSearchInput = {
  q: string;
  scope: string;
  status: string;
  limit: number;
  from: number;
  startUpdatedDate?: string;
  endUpdatedDate?: string;
};

export type ProductSearchVars = {
  q?: string;
  brand?: string;
  status?: string;
  packaging: string;
  dateFrom?: string;
  dateTo?: string;
  limit: number;
  from: number;
};

export function buildProductSearchVars(i: ProductSearchInput): ProductSearchVars {
  return {
    q: i.q && i.q.trim() ? i.q.trim() : undefined,
    brand: i.scope && i.scope !== "ALL" ? i.scope : undefined,
    status: i.status && i.status !== "ALL" ? i.status : undefined,
    packaging: "EA",
    dateFrom: i.startUpdatedDate ? new Date(i.startUpdatedDate).toISOString() : undefined,
    dateTo: i.endUpdatedDate ? new Date(i.endUpdatedDate).toISOString() : undefined,
    limit: i.limit,
    from: i.from,
  };
}
